export const PRIZES_TYPE = [
  {
    levelName: "A",
    levelUrl: require("@/assets/images/YuliApp/icon_jinhua_a@2x.png"),
    propsUrl: require("@/assets/images/YuliApp/icon_exp@2x.png"),
    propsName: "EXP item",
    level: 2,
  },
  {
    levelName: "S",
    levelUrl: require("@/assets/images/YuliApp/icon_jinhua_s@2x.png"),
    propsUrl: require("@/assets/images/YuliApp/icon_pingzi@2x.png"),
    propsName: "Stamina item",
    level: 1,
  },
  {
    levelName: "SR",
    levelUrl: require("@/assets/images/YuliApp/icon_jinhua_sr@2x.png"),
    propsUrl: require("@/assets/images/YuliApp/icon_card@2x.png"),
    propsName: "Attribute Reset Card",
    level: 0,
  },
  {
    levelName: "SSR",
    levelUrl: require("@/assets/images/YuliApp/icon_jinhua_ssr@2x.png"),
    propsUrl: require("@/assets/images/YuliApp/icon_cards@2x.png"),
    propsName: "Chip Set",
    level: 5,
  }
]

// export const COLLECTIONS_TYPE = [
//   {
//     levelName: "A",
//     level: 2,
//     cardUrlList: [
//       require("@/assets/images/YuliApp/collectionA/icon_wuliaowa@2x.png"),
//       require("@/assets/images/YuliApp/collectionA/icon_qitoupi@2x.png"),
//       require("@/assets/images/YuliApp/collectionA/icon_twinkle@2x.png"),
//       require("@/assets/images/YuliApp/collectionA/icon_ys@2x.png"),
//       require("@/assets/images/YuliApp/collectionA/icon_suipian@2x.png"),
//     ],
//   },
//   {
//     levelName: "S",
//     level: 1,
//     cardUrlList: [
//       require("@/assets/images/YuliApp/collectionS/icon_muteking@2x.png"),
//       require("@/assets/images/YuliApp/collectionS/icon_jiulongshenhuo@2x.png"),
//       require("@/assets/images/YuliApp/collectionS/icon_timkov@2x.png"),
//       require("@/assets/images/YuliApp/collectionS/icon_seekmen@2x.png"),
//       require("@/assets/images/YuliApp/collectionS/icon_opty@2x.png"),
//     ],
//   },
//   {
//     levelName: "SR",
//     level: 0,
//     cardUrlList: [
//       require("@/assets/images/YuliApp/collectionSR/icon_ruci@2x.png"),
//       require("@/assets/images/YuliApp/collectionSR/icon_O@2x.png"),
//       require("@/assets/images/YuliApp/collectionSR/icon_runba@2x.png"),
//       require("@/assets/images/YuliApp/collectionSR/icon_Kuma@2x.png"),
//       require("@/assets/images/YuliApp/collectionSR/icon_susu@2x.png"),
//     ],
//   },
//   {
//     levelName: "SSR",
//     level: 1,
//     cardUrlList: [
//       require("@/assets/images/YuliApp/collectionSSR/icon_ancienttwo@2x.png"),
//       require("@/assets/images/YuliApp/collectionSSR/icon_dora@2x.png"),
//       require("@/assets/images/YuliApp/collectionSSR/icon_neko@2x.png"),
//       require("@/assets/images/YuliApp/collectionSSR/icon_zuopun@2x.png"),
//       require("@/assets/images/YuliApp/collectionSSR/icon_hot296dog@2x.png"),
//     ]
//   }
// ]

